import { AsyncPipe, NgIf } from '@angular/common';
import { Component, Self } from '@angular/core';
import { BasketSummaryComponent } from '@domgen/dgx-fe-basket';
import {
  ButtonGroupComponent,
  ButtonNavigateBackComponent,
  ButtonTextComponent,
} from '@domgen/dgx-fe-components/button';
import { CardComponent } from '@domgen/dgx-fe-components/card';
import {
  GridColumnComponent,
  GridContainerComponent,
  GridRowComponent,
  GridSectionComponent,
} from '@domgen/dgx-fe-components/grid';
import { GAPage } from '@domgen/dgx-fe-ga';
import {
  provideTranslationDictionaryMapping,
  TranslatePipe,
} from '@domgen/dgx-fe-i18n';
import { CheckoutGuestComponent } from '../../components/checkout-guest/checkout-guest.component';
import { SignInFormComponent } from '../../components/sign-in-form/sign-in-form.component';
import { translation } from '../../i18n/translation.constants';
import { LandingComponentService } from '../../services/landing-component/landing-component.service';

@Component({
  templateUrl: './landing.component.html',
  styleUrls: ['./landing.component.scss'],
  standalone: true,
  imports: [
    AsyncPipe,
    BasketSummaryComponent,
    ButtonGroupComponent,
    ButtonNavigateBackComponent,
    ButtonTextComponent,
    CardComponent,
    CheckoutGuestComponent,
    GridColumnComponent,
    GridContainerComponent,
    GridRowComponent,
    GridSectionComponent,
    NgIf,
    SignInFormComponent,
    TranslatePipe,
  ],
  providers: [
    LandingComponentService,
    provideTranslationDictionaryMapping(translation),
  ],
})
@GAPage()
export class LandingComponent {
  constructor(@Self() readonly cs: LandingComponentService) {}
}
